'use client';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { WISHLIST_QUERIES } from '@/infrastructure/wishlist/utils/queries';
import type { GetWishlistRequest } from '@/infrastructure/wishlist/utils/types';
import { useWishlistCustomerKey } from '@/contexts/wishlistCustomerKeyContext';

export const useWishlistService = () => {
  const useGetWishlist = (payload: GetWishlistRequest) => {
    const { setCustomerKey } = useWishlistCustomerKey();
    return useQuery({
      ...WISHLIST_QUERIES.getWishlist(payload),
      select: (data) => {
        setCustomerKey(data.customerKey);
        return data;
      },
    });
  };

  const useAddProductToWishlist = () => {
    const queryClient = useQueryClient();
    return useMutation(WISHLIST_QUERIES.addProductToWishlist(queryClient));
  };

  const useRemoveProductFromWishlist = () => {
    const queryClient = useQueryClient();
    return useMutation(WISHLIST_QUERIES.removeProductFromWishlist(queryClient));
  };

  return {
    useAddProductToWishlist,
    useRemoveProductFromWishlist,
    useGetWishlist,
  };
};
